// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Menu from 'components/Menu/Menu'
import Link from 'components/Link/Link'
import Logo from 'components/svg/logo/logo-loading.svg'

class HeaderPrimary extends React.Component {
	constructor() {
		super()

		this.state = {
			logoIsHidden: false
		}
	}

	componentDidMount() {
		setTimeout( () => {
			this.setState( {
				logoIsHidden: true
			} )
		}, ( siteData.loading_delay_seconds * 1000 ) + 4000 )
	}

	render() {
		const { match, menuItems, menuItemsSecondary } = this.props
		const { logoIsHidden } = this.state
		const logoClass = logoIsHidden ? 'is-hidden' : ''

		return (
			<header className="header">
				<div className="-inner">
					<div className="logo">
						<Link to="/" className={ logoClass }>
							<Logo />

							<span>Merryn Nethercote</span>
						</Link>
					</div>

					<Menu className="primary-menu-wrap" match={ match } data={ menuItems } />
					<Menu className="secondary-menu-wrap" match={ match } data={ menuItemsSecondary } />
				</div>
			</header>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		menuItems: state.site.menuItems,
		menuItemsSecondary: state.site.menuItemsSecondary
	}
}

export default connect( mapStateToProps )( HeaderPrimary )



// WEBPACK FOOTER //
// ./components/HeaderPrimary/HeaderPrimary.jsx